import { Http } from '@/lib/http';

export class NotificationService extends Http {
  constructor() {
    super();
    this.endpoint = 'settings/system-settings/notification-management';
  }

  async getConfigByModule(module) {
    return await this.httpClient().get(`${this.endpoint}/${module}`);
  }

  async getConfig() {
    return await this.httpClient().get(`${this.endpoint}`);
  }

  async updateConfig(id, updates) {
    return await this.httpClient().patch(`${this.endpoint}/${id}`, updates);
  }
}